import { render, staticRenderFns } from "./OutrasHabilidades.vue?vue&type=template&id=f0258f50&lang=pug"
import script from "./OutrasHabilidades.vue?vue&type=script&lang=js"
export * from "./OutrasHabilidades.vue?vue&type=script&lang=js"
import style0 from "./OutrasHabilidades.vue?vue&type=style&index=0&id=f0258f50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports